import US from "../assets/images/EU.svg";
import NGN from "../assets/images/ngnnigeria.jpg";
import EU from "../assets/images/usds.svg";
import GB from "../assets/images/GB.svg";
const currency = [
    {
        img: NGN,
        name: "NGN",
        title: "NG Naira",
    },
    {
        img: GB,
        name: "GBP",
        title: " British Pounds",
    },

    {
        img: US,
        name: "EUR",
        title: "Euro",
    },
    {
        img: EU,
        name: "USD",
        title: "USD Dollar",
    },
];
export default function currencyList(props) {
    return currency.find((currencyItem) => currencyItem.name === props);
}

export const checkCurrency = (currency) => {
    switch (currency) {
        case "NGN":
            return "NGN ";
        case "USD":
            return "USD ";
        case "EUR":
            return "EUR ";
        case "GBP":
            return "GBP ";
        case "GHS":
            return "GHS ";
        case "KES":
            return "KES ";
        case "UGX":
            return "UGX ";
        case "CAD":
            return "CAD ";
        case "USDC":
            return "USDC ";
        case "USDT":
            return "USDT ";
        default:
            return "";
    }
}